import { BaseDataService } from './BaseDataService';
import { Organization, Report9BoxSettings } from '../../models';
import { NotificationService } from '../../services';
import { OpenBlobFile } from '../../utilities';

export class Report9BoxDataService extends BaseDataService<Report9BoxSettings> {
    constructor(notificationService: NotificationService) {
        super('Report9Box', 'Report9Box', notificationService);
    }

    public getConfig(organization: Organization): Promise<any> {
        const endpoint = `${this.endpointRoot}/config/${organization.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    public updateConfig(organization: Organization, data: any): Promise<any> {
        const endpoint = `${this.endpointRoot}/config/${organization.id}`;
        const init = this.buildRequestInit('PUT', data);

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    public getSnapshots(orgId: number, teamId: number): Promise<any> {
        let endpoint = `${this.endpointRoot}/snapshots/${orgId}`;
        endpoint = `${endpoint}${this.getTeamTypeEndpointExtension(teamId)}`;

        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    public updateUser(data: any, orgId: number, teamId: number): Promise<any> {
        let endpoint = `${this.endpointRoot}/userstate/${orgId}`;
        
        const init = this.buildRequestInit('PUT', data);

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    public getUserStatesByTeam(orgId: number, teamId: number): Promise<any> {
        let endpoint = `${this.endpointRoot}/userstate/byTeam/${orgId}`;
        endpoint = `${endpoint}${this.getTeamTypeEndpointExtension(teamId)}`;
        
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    public getUserStatesBySnapshot(snapshotId: number): Promise<any> {
        let endpoint = `${this.endpointRoot}/userstate/bySnapshot/${snapshotId}`;
        
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    public getUserStatesByOrganization(organization: Organization): Promise<any> {
        const endpoint = `${this.endpointRoot}/userstate/byOrganization/${organization.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    public snapshot(orgId: number, teamId: number): Promise<any> {
        const endpoint = `${this.endpointRoot}/snapshot`;

        const body = {
            orgId: orgId,
            teamId: teamId,
            teamType: teamId < 0 ? teamId : 0
        };

        const init = this.buildRequestInit('PUT', body);

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    private getTeamTypeEndpointExtension(teamId: number): string {
        if (teamId > 0) {
            return `/Team/${teamId}`;
        } else if (teamId === -100) {
            return `/AllUsers`;
        } else if (teamId === -200) {
            return `/Candidates`;
        } else if (teamId === -300) {
            return `/FormerEmployees`;
        }

        return ``;
    }

    public getCSVByTeam(orgId: number, teamId: number): Promise<any> {
        let endpoint = `${this.endpointRoot}/csv/${orgId}`;
        endpoint = `${endpoint}${this.getTeamTypeEndpointExtension(teamId)}`;

        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.blob();
            }
            const message = `Error retrieving survey responses.`;
            this.notificationService.addError(message);
            throw new Error(message);
        }).then((blobData: any) => {
            return OpenBlobFile(blobData, '9Box.csv');
        });
    }

    public getPDFByTeam(orgId: number, teamId: number): Promise<any> {
        let endpoint = `${this.endpointRoot}/pdf/${orgId}`;
        endpoint = `${endpoint}${this.getTeamTypeEndpointExtension(teamId)}`;

        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.blob();
            }
            const message = `Error retrieving survey responses.`;
            this.notificationService.addError(message);
            throw new Error(message);
        }).then((blobData: any) => {
            return OpenBlobFile(blobData, '9Box.pdf');
        });
    }

    public getCSVBySnapshot(snapshotId: number): Promise<any> {
        let endpoint = `${this.endpointRoot}/csv/bySnapshot/${snapshotId}`;

        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.blob();
            }
            const message = `Error retrieving survey responses.`;
            this.notificationService.addError(message);
            throw new Error(message);
        }).then((blobData: any) => {
            return OpenBlobFile(blobData, '9Box.csv');
        });
    }

    public getPDFBySnapshot(snapshotId: number): Promise<any> {
        let endpoint = `${this.endpointRoot}/pdf/bySnapshot/${snapshotId}`;

        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.blob();
            }
            const message = `Error retrieving survey responses.`;
            this.notificationService.addError(message);
            throw new Error(message);
        }).then((blobData: any) => {
            return OpenBlobFile(blobData, '9Box.pdf');
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/api/Report9BoxData.tsx